var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ef5b5b;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3098.937 -676.417)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3119.175,692.983l-6.921-10.812a1.56,1.56,0,0,0-2.628,0l-6.926,10.812a1.56,1.56,0,0,0,1.314,2.4h13.846a1.56,1.56,0,0,0,1.314-2.4Zm-9.107-7.136a.861.861,0,0,1,1.721,0v3.693a.861.861,0,0,1-1.721,0Zm.845,7.671a1.076,1.076,0,1,1,1.076-1.076A1.076,1.076,0,0,1,3110.913,693.518Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(3098.937 676.417)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23,
    height: 23,
    transform: "translate(3099.437 676.917)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.ab6c12648e069574265e8eb68db099a1.svg";
export { ForwardRef as ReactComponent };